import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { realityTags } from '../../data/content';
import { images } from '../../data/images';
export function RealLifeSection() {
  return <Section tone="ink" data-id="element-203" data-mp="2bz1wd2d02k1b">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-204" data-mp="2bv4esl62m0jj">
        <figure className="order-2 lg:order-1 lg:col-span-5" data-id="element-205" data-mp="26xma56z367hc">
          <img src={images.realLife} alt="Trabajador latino comiendo su comida preparada dentro del carro de noche" className="aspect-[4/5] w-full rounded-lg border border-line object-cover" data-id="element-206" data-mp="2lv4yw9brkkos" />
        </figure>

        <div className="order-1 lg:order-2 lg:col-span-7" data-id="element-207" data-mp="2uq2w3sly2jlx">
          <SectionTitle data-id="element-208" data-mp="2qnfzzfi8qcix">
            Tu problema no es vivir en Estados Unidos.{' '}
            <Accent data-id="element-209" data-mp="34lmmy0lnis3t">El problema es no tener un plan para esa realidad.</Accent>
          </SectionTitle>

          <div className="mt-10 space-y-6 text-lg leading-relaxed text-muted" data-id="element-210" data-mp="2znun8kerm1p2">
            <p data-id="element-211" data-mp="1w8dgq12xc05x">Si eres latino/a en USA, sabes que no siempre es fácil cuidar tu cuerpo.</p>
            <ul className="flex flex-wrap gap-2.5" data-id="element-212" data-mp="2176wk05oo399">
              {realityTags.map(t => <li key={t} className="rounded-md border border-line bg-surface px-4 py-2 text-base text-white" data-id="element-213" data-mp="266b1gelkrets">
                  {t}
                </li>)}
            </ul>
            <p className="font-display text-3xl font-bold uppercase leading-tight text-white" data-id="element-214" data-mp="2a5jvlkkj1epv">
              Por eso un plan genérico no sirve.
            </p>
            <p data-id="element-215" data-mp="2k4rjh1ow0rr8">
              Necesitas saber qué hacer con <span className="text-white" data-id="element-216" data-mp="2owss8dmuk0ci">tu vida real</span>, no con una versión
              perfecta de tu agenda.
            </p>
            <p data-id="element-217" data-mp="2tw5fv0ljlbg5">
              En este diagnóstico vamos a revisar tu situación actual y ayudarte a entender qué pasos tendrían más
              sentido para ti.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-20 rounded-lg bg-surface px-6 py-12 text-center sm:px-12 md:py-16" data-id="element-218" data-mp="32xbzhijhn2dm">
        <p className="mx-auto max-w-5xl font-display text-3xl font-black uppercase leading-[1] text-white sm:text-5xl" data-id="element-219" data-mp="12vcb76akekuk">
          Tu horario, tu comida y tu estilo de vida <span className="text-brand" data-id="element-220" data-mp="1cjub7lb0snx5">también tienen que ser parte del plan.</span>
        </p>
      </div>
    </Section>;
}